module.exports = __webpack_public_path__ + "assets/img/travel-day47.36b9dad3.png";